/* US federal holidays — actual calendar dates (not weekend-observed shifts). */

const iso = (d) => d.toISOString().slice(0, 10);

const nthWeekday = (year, month, weekday, n) => {
  const first = new Date(Date.UTC(year, month, 1));
  const offset = (weekday - first.getUTCDay() + 7) % 7;
  return new Date(Date.UTC(year, month, 1 + offset + (n - 1) * 7));
};

const lastWeekday = (year, month, weekday) => {
  const last = new Date(Date.UTC(year, month + 1, 0));
  const offset = (last.getUTCDay() - weekday + 7) % 7;
  return new Date(Date.UTC(year, month + 1, 0 - offset));
};

export function usFederalHolidays(year) {
  return [
    `${year}-01-01`,               // New Year's Day
    iso(nthWeekday(year, 0, 1, 3)), // MLK Day — 3rd Mon of Jan
    iso(nthWeekday(year, 1, 1, 3)), // Washington's Birthday — 3rd Mon of Feb
    iso(lastWeekday(year, 4, 1)),   // Memorial Day — last Mon of May
    `${year}-06-19`,               // Juneteenth
    `${year}-07-04`,               // Independence Day
    iso(nthWeekday(year, 8, 1, 1)), // Labor Day — 1st Mon of Sep
    iso(nthWeekday(year, 9, 1, 2)), // Columbus Day — 2nd Mon of Oct
    `${year}-11-11`,               // Veterans Day
    iso(nthWeekday(year, 10, 4, 4)),// Thanksgiving — 4th Thu of Nov
    `${year}-12-25`,               // Christmas Day
  ];
}
